import useCustomer from '~/features/commerce-api/hooks/useCustomer';
import { useErrorHandler } from '~/shared/utils/errorBoundary/hooks/useErrorHandler';
import { useTranslation } from '~/shared/utils/translation';

export const useLoyaltyContext = () => {
    const { businessCentralId, isPlusMember } = useCustomer();
    const { trackAndDisplayError: trackError, trackOnlyError } = useErrorHandler();
    const { translate } = useTranslation();

    const canFetchLoyaltyData = Boolean(isPlusMember && businessCentralId);

    return {
        canFetchLoyaltyData,
        businessCentralId,
        isPlusMember,
        trackError,
        trackOnlyError,
        translate,
    };
};
